interface RocheUIVideoPlayerSettings {
  brightcove: BrightcoveVideoPlayerSettings;
}

export interface BrightcoveVideoPlayerSettings {
  accountId: string;
  playerId: string;
}

export const settings: RocheUIVideoPlayerSettings = {
  brightcove: {
    accountId: process.env.GATSBY_BRIGHTCOVE_ACCOUNT_ID,
    playerId: process.env.GATSBY_BRIGHTCOVE_PLAYER_ID,
  },
};
